var DateSpans = require("lib/data/DateSpans");

var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");

var CurrentUser = require('lib/account/CurrentUser');
var DataRouting = require("lib/routing/DataRouting");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ReactTooltip = require("react-tooltip");

import DatePicker from "react-datepicker";

import moment from "moment";

require("data/date_span_selector.scss");

class DateSpanSelector extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = this.getInitialState();
	}

	getInitialState() {
		return {
			showDatePicker: false, showOtherPeriodPicker: false,
			tempStartDate: null, tempEndDate: null
		}
	}

	confirmCustomDates() {
		var startDate = this.state.tempStartDate;
		var endDate = this.state.tempEndDate;
		this.setState(this.getInitialState(), () => {
			this.props.onSelectDates(startDate, endDate);
		});
	}

	getAllDates() {
		if (CurrentUser.get().first_active) {
			var start = $wr.formatDate(new Date(CurrentUser.get().first_active), "YYYY-MM-DD")
			var end = $wr.formatDate(new Date(), "YYYY-MM-DD")
			return {start, end}
		}
	}

	selectDate(dateSpan, e) {
		$wr.nope(e)
		if (dateSpan.label == DateSpans.CUSTOM_DATES) {
			this.setState({
				showDatePicker: true, showOtherPeriodPicker: false,
				tempStartDate: this.props.startDate, tempEndDate: this.props.endDate
			});

		} else if (dateSpan.label == DateSpans.OTHER_PERIODS) {
			this.setState(_.extend({}, this.getInitialState(), { showOtherPeriodPicker: true }));

		} else {
			this.setState(this.getInitialState(), () => {
				if (dateSpan.label == ALL_DATES_LABEL) {
					dateSpan.value = this.getAllDates() || {}
				}
				this.props.onSelectDates(dateSpan.value.start, dateSpan.value.end);
			});
		}
	}

	renderCurrentLabel() {
		if (this.state.showDatePicker) {
			// Don't show any dates
			return (
				<span>{ DateSpans.CUSTOM_DATES }</span>
			);
		}

		if (this.state.showOtherPeriodPicker) {
			// Don't show any dates
			return (
				<span>{ DateSpans.OTHER_PERIODS }</span>
			);			
		}

		if (this.props.noDatesOption && (this.props.startDate == undefined) && (this.props.endDate == undefined)) {
			if (this.props.widgetMode) {
				if (this.props.expectationsSpans && this.props.expectationsSpans.length > 0) {
					var label = this.props.expectationsSpans[0].label
				} else {
					var label = ALL_DATES_LABEL
				}
				
				return (
					<span>{ label }</span>
				);
			} else {
				return (
					<span>{ ALL_DATES_LABEL }</span>
				);
			}
		}

		var isCurrentSpan = (span) => {
			return (span.value.start == this.props.startDate) && (span.value.end == this.props.endDate);
		}

		var conditions = { value: { start: this.props.startDate, end: this.props.endDate } };
		var match = _.find(DateSpans.dashboardSpans(this.props.expectationsSpans), isCurrentSpan);

		if (!match) {
			match = _.find(DateSpans.otherExpectationsSpans(this.props.expectationsSpans), isCurrentSpan);
		}

		if (match) {
			var label = match.label;
		} else {
			var label = DateSpans.CUSTOM_DATES;
		}

		var startDate = moment(this.props.startDate).format("M/DD/YY");
		var endDate = moment(this.props.endDate).format("M/DD/YY");

		return (
			<span>
				{ label }{" "}
				<span className="spanDates">
					({ startDate } - { endDate })
				</span>
			</span>
		);
	}

	renderDatePickers() {
		return (
			<div className="datePickerContainer">
				<DatePicker readOnly={ true } selected={ moment(this.state.tempStartDate) }
					onChange={ (date) => this.setState({ tempStartDate: date.format(DateSpans.FORMAT) }) } />

				<span>To</span>

				<DatePicker readOnly={ true } minDate={ moment(this.state.tempStartDate) }
					selected={ moment(this.state.tempEndDate) }
					onChange={ (date) => this.setState({ tempEndDate: date.format(DateSpans.FORMAT) }) } />

				<button className="btn buttonPrimary confirmBtn"
					onClick={ this.confirmCustomDates }>Set</button>
			</div>
		)
	}

	renderOtherSpanSelector() {
		var spanOptions = _.map(DateSpans.otherExpectationsSpans(this.props.expectationsSpans), (option) => {
			if ((option.label == DateSpans.CUSTOM_DATES) || (option.label == DateSpans.OTHER_PERIODS)) {
				var text = (<span>{ option.label }</span>);
			} else {
				var text = DateSpans.renderSpan(option);
			}

			return (
				<ButtonDropdownOption onClick={ this.selectDate.bind(this, option) }
					text={ text } key={ option.label } />
			)
		});

		return (
			<ButtonDropdown text="Select Time Period" dropdownDisplay="link">
				{ spanOptions }
			</ButtonDropdown>  
		);

	}


	renderMainSpanSelector() {
		var spanOptions = _.map(DateSpans.dashboardSpans(this.props.expectationsSpans), (option) => {
			if ((option.label == DateSpans.CUSTOM_DATES) || (option.label == DateSpans.OTHER_PERIODS)) {
				var text = (<span>{ option.label }</span>);
			} else {
				var text = DateSpans.renderSpan(option);
			}

			return (
				<ButtonDropdownOption onClick={ this.selectDate.bind(this, option) }
					text={ text } key={ option.label } />
			)
		});

		if (this.props.noDatesOption && this.props.showAllDates) {
			var placeholderOp = { label: ALL_DATES_LABEL, value: {} };
			var onDatesOption = (
				<ButtonDropdownOption onClick={ this.selectDate.bind(this, placeholderOp) }
					text={ ALL_DATES_LABEL } />
			);
		}

		var timePeriodLabel = this.renderCurrentLabel();

		return (
			<ButtonDropdown text={ timePeriodLabel } dropdownDisplay="link">
				{ onDatesOption }
				{ spanOptions }
			</ButtonDropdown>  
		);
	}

	renderWidgetSpanSelector() {
		var spanOptions = _.map(DateSpans.widgetSpans(this.props.expectationsSpans), (option) => {
		
			if ((option.label == DateSpans.CUSTOM_DATES) || (option.label == DateSpans.OTHER_PERIODS)) {
				var text = (<span>{ option.label }</span>);
			} else {
				var text = DateSpans.renderSpan(option);
			}

			return (
				<ButtonDropdownOption onClick={ this.selectDate.bind(this, option) }
					text={ text } key={ option.label } />
			)
		});

		if (this.props.noDatesOption && this.props.showAllDates) {
			var placeholderOp = { label: ALL_DATES_LABEL, value: {} };
			var onDatesOption = (
				<ButtonDropdownOption onClick={ this.selectDate.bind(this, placeholderOp) }
					text={ ALL_DATES_LABEL } />
			);
		}

		var timePeriodLabel = this.renderCurrentLabel();

		var dataTip = 'View all dates and metrics<br/>on the Other Stats table'
		var moreDatesOption = (
			<ButtonDropdownOption className='otherStatsMenuOption' onClick={() => this.props.updateLocationState({ subjectType: DataRouting.SUBJECT_OTHER_METRICS })}
				text={MORE_DATES_LABEL} >
				<span className="otherStatsInfoSign" data-tip={dataTip} data-for={dataTip} data-html={true}>
					<Glyphicon icon="info-sign" />
					<ReactTooltip effect="solid" id={dataTip} />
				</span>
			</ButtonDropdownOption>
		);

		return (
			<ButtonDropdown text={ timePeriodLabel } dropdownDisplay="link">
				{ onDatesOption }
				{ spanOptions }
				{ moreDatesOption }
			</ButtonDropdown>  
		);
	}

	render() {
		if (this.props.widgetMode) {
			var mainSpanSelector = this.renderWidgetSpanSelector();
		} else {
			var mainSpanSelector = this.renderMainSpanSelector();
		}
	

		if (this.state.showOtherPeriodPicker) {
			var otherTimeSpanSelectors = this.renderOtherSpanSelector();
		}

		if (this.state.showDatePicker) {
			var datePickers = this.renderDatePickers()
		}

		return (
			<span className="dateSpanSelector">
				{ mainSpanSelector }
				{ otherTimeSpanSelectors }
				{ datePickers }
			</span>
		);
	}
};

var ALL_DATES_LABEL = "All Dates";
var MORE_DATES_LABEL = "More Dates";
var EXPECTATION_PERIOD_LABELS = {
	"weekly": "Current Week",
	"month": "Current Month",
	"trimester": "Current Trimester",
	"semester": "Current Semester",
	"school-year": "Current School Year"
}

DateSpanSelector.propTypes = StrictPropTypes({
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	onSelectDates: PropTypes.func.isRequired,
	updateLocationState: PropTypes.func,
	noDatesOption: PropTypes.bool,
	showAllDates: PropTypes.bool,
	widgetMode: PropTypes.bool,
	expectationsSpans: PropTypes.array
});

module.exports = DateSpanSelector;



// WEBPACK FOOTER //
// ./modules/components/data/DateSpanSelector.js